export function asDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value?.toDate === 'function') return value.toDate();
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatMoney(amount) {
  const num = Number(amount || 0);
  return `R ${num.toLocaleString('en-ZA')}`;
}

export function formatTime(value) {
  const dt = asDate(value);
  if (!dt) return '—';
  return dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
}

export function formatDateTime(value) {
  const dt = asDate(value);
  if (!dt) return '—';
  return dt.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function formatDuration(seconds) {
  const total = Math.max(0, Number(seconds || 0));
  const mins = Math.floor(total / 60);
  const hrs = Math.floor(mins / 60);
  const remMins = mins % 60;
  const remSecs = total % 60;
  if (hrs > 0) return `${hrs}h ${remMins}m`;
  if (mins > 0) return `${mins}m ${remSecs}s`;
  return `${remSecs}s`;
}

export function ageMinutes(value) {
  const dt = asDate(value);
  if (!dt) return 0;
  return Math.max(0, Math.floor((Date.now() - dt.getTime()) / 60000));
}

export function urgencyMeta(order) {
  const mins = ageMinutes(order?.placedAt || order?.createdAt);
  const stage = order?.stage;
  if (stage === 'delivered') return { label: 'Delivered', tone: 'text-emerald-300 border-emerald-400/30 bg-emerald-500/10' };
  if (mins >= 45 || order?.issueFlag) return { label: 'Overdue', tone: 'text-rose-300 border-rose-400/30 bg-rose-500/10' };
  if (mins >= 20) return { label: `+${mins} min waiting`, tone: 'text-amber-300 border-amber-400/30 bg-amber-500/10' };
  return { label: 'On time', tone: 'text-emerald-300 border-emerald-400/30 bg-emerald-500/10' };
}

export function whatsappHref(phone, text) {
  const cleaned = String(phone || '').replace(/[^\d]/g, '');
  const encoded = encodeURIComponent(text || '');
  if (!cleaned) return `https://wa.me/?text=${encoded}`;
  return `https://wa.me/${cleaned}?text=${encoded}`;
}
